var _path, _path2, _path3, _path4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldwave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 148,
    viewBox: "0 0 113 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.8209 15.7024C88.6643 15.862 81.6759 19.2799 81.6759 19.2799L25.5566 77.8699L58.6054 78.0333L15.9872 129.634L28.5763 123.191L100.83 58.5667L63.8214 57.6499L88.8209 15.7024Z",
    fill: "url(#paint0_linear_89_1491)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.8209 15.7024C88.6643 15.862 81.6759 19.2799 81.6759 19.2799L25.5566 77.8699L58.6054 78.0333L15.9872 129.634L28.5763 123.191L100.83 58.5667L63.8214 57.6499L88.8209 15.7024Z",
    fill: "url(#paint1_linear_89_1491)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6761 19.28C80.9544 19.8876 12.9678 84.3133 12.9678 84.3133L46.0166 84.4767L15.9874 129.634L89.2852 65.0318L51.2325 64.0933L81.6761 19.28Z",
    fill: "url(#paint2_linear_89_1491)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_89_1491",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 19,
    width: 78,
    height: 111
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6761 19.28C80.9544 19.8876 12.9678 84.3133 12.9678 84.3133L46.0166 84.4767L15.9874 129.634L89.2852 65.0318L51.2325 64.0933L81.6761 19.28Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_89_1491)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_1491",
    x1: 39.7083,
    y1: 50.6714,
    x2: 63.7098,
    y2: 92.3582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2AB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0554437,
    stopColor: "#F78900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#D46200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#9F4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#9F4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4019,
    stopColor: "#BA5600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5213,
    stopColor: "#F78900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#F78900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7337,
    stopColor: "#D46200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7601,
    stopColor: "#A74B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7742,
    stopColor: "#8B3D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9907,
    stopColor: "#8B3D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_89_1491",
    x1: 39.7083,
    y1: 50.6714,
    x2: 63.7098,
    y2: 92.3582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2AB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0554437,
    stopColor: "#F78900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#D46200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#9F4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#9F4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4019,
    stopColor: "#BA5600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5213,
    stopColor: "#F78900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#F78900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7337,
    stopColor: "#D46200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7601,
    stopColor: "#A74B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7742,
    stopColor: "#8B3D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9907,
    stopColor: "#8B3D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_89_1491",
    x1: 19.1923,
    y1: 64.9062,
    x2: 82.6583,
    y2: 85.4001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F88909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C109"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldwave);
export default __webpack_public_path__ + "static/media/goldwave.a8e648da8002996759d4670485c31982.svg";
export { ForwardRef as ReactComponent };